<template>
  <div class="wrap-select fontSpecial">
    <div class="top-bg">
      <div class="pags">
        <p>{{answerNo}}/{{questionLength}}</p>
      </div>
    </div>
    <div class="bottom-bg"></div>
    <div class="content-box">
      <!--  -->
      <div class="title">
        <span>{{singleQuestion.questionContent}}</span>
      </div>
      <div
        class="item"
        @click="handleSelect(item.value)"
        v-for="(item,index) in answerArr"
        :key="index"
        :class="currentSelect==item.value?'active-item':''"
      >
        <span>{{item.label}}</span>
      </div>
      <!--  -->
      <div class="submit">
        <button :class="answerNo==questionLength?'submit-all':'submit-next'" @click="handleSubmit"></button>
      </div>
    </div>
  </div>
</template>
<script>
import { getApi, postApi } from '../../api/index.js'
import { setTimeout } from 'timers'
export default {
  data() {
    return {
      currentSelect: '',
      questionList: [],
      singleQuestion: {},
      questionLength: 0,
      answerArr: [
        {
          label: 'A、没有（根本不）',
          value: 'answerA'
        },
        {
          label: 'B、很少（有一点）',
          value: 'answerB'
        },
        {
          label: 'C、有时（有些）',
          value: 'answerC'
        },
        {
          label: 'D、经常（相当）',
          value: 'answerD'
        },
        {
          label: 'E、总是（非常）',
          value: 'answerE'
        }
      ],
      answerAll: {},
      currentScore: 0,
      answerNo: 1
    }
  },
  created() {
    this.personId = this.$route.query.personId
    this.getList()
    console.log(this.$route)
  },
  methods: {
    getList() {
  
      getApi({ url: '/chinese/getQuestion/' + this.$route.query.personId, query: {} })
        .then(res => {
          console.log(res);
          if (res && res.resCode == 0) {
            if (res.data) {
              
              this.questionList = res.data
              if (this.questionList.length > 0) {
                this.singleQuestion = this.questionList[0]
                this.questionLength = this.questionList.length
              }
            }
          }
        })
        .catch(res => {})
    },
    handleSelect(item) {
      // 判断有没有key，没有key就set一个
      if (!this.answerAll['answer' + this.singleQuestion.bodyType]) {
        this.$set(this.answerAll, 'answer' + this.singleQuestion.bodyType, '')
      }
      this.currentScore = this.singleQuestion[item]
      this.currentSelect = item
    },
    handleSubmit() {
      this.currentSelect = ''
      if (!this.currentScore) {
        this.$toast('请选择答案')
      } else {
        if (this.answerNo == this.questionLength) {
          // 最后一题的答案先存一下
          if (this.answerAll['answer' + this.singleQuestion.bodyType]) {
            let arr = this.answerAll[
              'answer' + this.singleQuestion.bodyType
            ].split(';')

            arr.push(this.currentScore)
            let str = arr.join(';')
            this.answerAll['answer' + this.singleQuestion.bodyType] = str
          } else {
            this.answerAll['answer' + this.singleQuestion.bodyType] =
              this.currentScore + ''
          }

          let param = {
            personId: this.personId,
            ...this.answerAll
          }
          postApi({ url: '/chinese/submitAnswer', query: param })
            .then(res => {
              if (res && res.resCode == 0) {
                if (res.data) {
                  this.$toast('操作成功')
                  setTimeout(() => {
                    this.$router.push({
                      path: '/medical/detail',
                      query: { resultId: res.data.resultId || '' }
                    })
                  }, 3000)
                }
              } else {
                this.$toast(res.resMsg || '网络错误，请重试！')
              }
            })
            .catch(res => {
              this.$toast(res.resMsg || '网络错误，请重试！')
            })
          // 提交
        } else {
          // 下一题
          // if (
          //   this.answerAll['answer' + this.singleQuestion.bodyType].length <= 0
          // ) {
          //   this.answerAll['answer' + this.singleQuestion.bodyType].push(
          //     this.currentScore
          //   )
          // } else {
          //   this.answerAll['answer' + this.singleQuestion.bodyType].join('')
          // }
          // 如果有值，就先拆分成数组，塞值，在合并成字符串
          if (this.answerAll['answer' + this.singleQuestion.bodyType]) {
            let arr = this.answerAll[
              'answer' + this.singleQuestion.bodyType
            ].split(';')

            arr.push(this.currentScore)
            let str = arr.join(';')
            this.answerAll['answer' + this.singleQuestion.bodyType] = str
          } else {
            this.answerAll['answer' + this.singleQuestion.bodyType] =
              this.currentScore + ''
          }

          this.singleQuestion = this.questionList[Number(this.answerNo)]
          this.currentScore = 0
          this.answerNo++
          console.log(this.answerAll)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap-select {
  position: relative;
  background: url('../../assets/image/start/center-bg.png') repeat center;
  background-size: 100%;
  min-height: 100%;
  padding: 3rem 0 1.52rem;
  box-sizing: border-box;
  .content-box {
    // position: fixed;
    // left: 0;
    // top: 0;
    // width: 100%;
    // height: 100%;
    // z-index: 10;
  }
  .top-bg {
    position: absolute;
    left: 0;
    top: 0;
    background: url('../../assets/image/start/top-bg.png') no-repeat top;
    background-size: 100%;
    height: 3rem;
    width: 100%;
    z-index: 1;
  }
  .bottom-bg {
    width: 100%;
    height: 1.52rem;
    background: url('../../assets/image/start/short-bottom-bg.png') no-repeat
      bottom;
    background-size: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .header-box {
    height: 100%;
    // padding-bottom: 0.98rem;
    overflow: hidden;
    padding-left: 0.24rem;
    padding-right: 0.24rem;
    text-align: center;
  }
  .pags {
    padding-top: 2.19rem;
    font-size: 0.3rem;
    font-family: 'thin';
    text-align: center;
  }
  .title {
    display: block;
    padding: 0 1rem;
    // height: 1rem;
    font-size: 0.48rem;
    // font-family: 'thin';
    text-align: left;
    margin-bottom: 0.4rem;
  }

  .item {
    // text-align: left;
    margin: 0 auto;
    text-align: left;
    background: rgb(238, 238, 238);
    border-radius: 0.395rem;
    width: 4.8rem;
    height: 0.8rem;
    line-height: 0.8rem;
    box-sizing: border-box;
    // margin-left: 1rem;
    margin-bottom: 0.32rem;
    &.active-item {
      color: #fff;
      background-color: #787878;
    }
    span {
      font-size: 0.4rem;
      padding-left: 0.84rem;
      box-sizing: border-box;
    }
  }
  .submit {
    text-align: center;
    padding-top: 0.3rem;
  }
  .submit button {
    width: 3.03rem;
    height: 0.88rem;
    border-radius: 3rem;
    background-size: 100%;
    border: 0;
    text-align: center;
  }

  .submit-all {
    background-image: url('../../assets/image/select/submit.png');
  }
  .submit-next {
    background-image: url('../../assets/image/select/next.png');
  }
}
</style>

